import React, { FC } from 'react';
import { TableToggleAllRowsSelectedProps } from 'react-table';

export const TableCheckbox: FC<TableToggleAllRowsSelectedProps> = ({ indeterminate, ...restProps }) => (
  <input type="checkbox" {...restProps} />
);
